module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mrescir15-97b17ad22edec937eed3dfb71d9f9ea0.jpg";